function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m105.945312 512h105.445313v-63.902344l-125.460937-20.019531zm0 0",
  fill: "#ffd422"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m.5 448.097656v63.902344h105.445312v-83.921875zm0 0",
  fill: "#fff1b6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m105.945312 448.097656h105.445313v-182.519531l-125.460937-20.015625zm0 0",
  fill: "#ff9100"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m105.945312 245.5625-105.445312 20.015625v182.519531h105.445312zm0 0",
  fill: "#ffd422"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m210.402344 201.675781-124.472656-20.015625 20.015624 83.917969h105.445313v-31.949219c0-10.84375-.339844-21.507812-.988281-31.953125zm0 0",
  fill: "#ffd422"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m105.945312 181.660156-104.460937 20.015625c-.644531 10.445313-.984375 21.109375-.984375 31.953125v31.949219h105.445312zm0 0",
  fill: "#fff1b6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m210.402344 201.675781c-7.03125-113.910156-51.113282-201.675781-104.457032-201.675781l-20.015624 119 20.015624 82.675781zm0 0",
  fill: "#ff9100"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m105.945312 0c-53.34375 0-97.425781 87.765625-104.460937 201.675781h104.460937zm0 0",
  fill: "#ffd422"
});

function SvgBullet(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-150 0 511 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.a1366490.svg";
export { ForwardRef as ReactComponent };